/**
 * Global API-activity tracker. The apiClient interceptors increment on every
 * outbound request and decrement when it settles, so any UI (a top progress
 * bar, a route-change skeleton) can react to "is the app talking to the server".
 */
type Listener = (active: boolean, count: number) => void;

let count = 0;
const listeners = new Set<Listener>();

const emit = () => {
  const active = count > 0;
  listeners.forEach((l) => {
    try {
      l(active, count);
    } catch {
      /* a bad listener must never break request accounting */
    }
  });
};

export const apiActivity = {
  start() {
    count += 1;
    emit();
  },
  done() {
    count = Math.max(0, count - 1);
    emit();
  },
  get count() {
    return count;
  },
  /** Subscribe; immediately called with the current state. Returns unsubscribe. */
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    listener(count > 0, count);
    return () => {
      listeners.delete(listener);
    };
  },
};

export default apiActivity;
